import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { IntegrationConfig } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useIntegrationConfigQuery(
	options?: Omit<UseQueryOptions<IntegrationConfig, unknown, IntegrationConfig>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Integrations.Config(),
		() => AxiosUtils.getResponseData<IntegrationConfig>(api.get(CerebroApiEndpoints.Integrations.Config)),
		options
	);
}
